import { Alert, AlertTitle, Button, Dialog } from "@mui/material";

function MessageDialog({ isError, message, onClose, open, title }) {
  return (
    <Dialog open={open} fullWidth={false} maxWidth="sm">
      <Alert
        variant="outlined"
        severity={isError ? "error" : "success"}
        role={isError ? "error" : "alert"}
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message && <p>{message}</p>}
      </Alert>
      {onClose && (
        <Button color={isError ? "error" : "success"} onClick={onClose}>
          OK
        </Button>
      )}
    </Dialog>
  );
}

export default MessageDialog;
